var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dp-draft-create", {
    attrs: {
      subNavTitle: _vm.title,
      capsule: _vm.capsule,
      saveMessage: _vm.saveMessage,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }